module.exports = __webpack_public_path__ + "static/img/product3s-4.2512afa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-4.jpg
// module id = ftI3
// module chunks = 0